import { dramas } from "@/mocks/dramas";
import Reveal from "@/components/feature/Reveal";

export default function Exclusive() {
  const list = dramas.filter((d) => d.exclusive);
  const [lead, ...rest] = list;

  if (!lead) return null;

  return (
    <section id="exclusive" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label font-medium tracking-[0.18em] uppercase text-accent-300">
              <span className="w-6 h-px bg-accent-400" aria-hidden="true" />
              Exclusive Theater
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-background-50 leading-snug">
              韩剧TV 独播剧
            </h2>
            <p className="mt-3 md:mt-4 text-sm md:text-base text-background-50/70 leading-relaxed">
              独播剧场集中收录本站单独整理的剧集，作为一条更聚焦的观看线索。它们同样标注题材、评分与进度，方便你快速锁定口碑与热度都稳定的作品。
            </p>
          </div>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          <Reveal className="lg:row-span-1">
            <article className="h-full rounded-lg overflow-hidden bg-background-50/5 border border-background-50/15 flex flex-col sm:flex-row">
              <div className="w-full sm:w-2/5 aspect-[4/3] sm:aspect-auto sm:h-auto overflow-hidden bg-foreground-900">
                <img
                  src={lead.poster}
                  alt={`${lead.title} 独播韩剧海报`}
                  title={`${lead.title} 韩剧 独播剧场`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col">
                <div className="flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-md text-xs font-label font-medium bg-primary-500 text-background-50">
                    独播
                  </span>
                  <span className="text-xs font-label text-accent-300">
                    评分 {lead.score.toFixed(1)}
                  </span>
                </div>
                <h3 className="mt-3 text-xl md:text-2xl font-heading font-bold text-background-50">
                  {lead.title}
                </h3>
                <p className="mt-2 text-xs font-label text-background-50/60">
                  {lead.year} · 共{lead.episodes}集 · {lead.genres.join(" / ")}
                </p>
                <p className="mt-3 text-sm text-background-50/75 leading-relaxed flex-1">
                  {lead.synopsis}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {lead.tags.map((t) => (
                    <span
                      key={t}
                      className="px-2.5 py-1 rounded-full text-xs font-label text-background-50/80 bg-background-50/10 border border-background-50/15"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          </Reveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5 md:gap-6">
            {rest.map((drama, index) => (
              <Reveal key={drama.id} delay={index * 80}>
                <article className="h-full rounded-lg overflow-hidden bg-background-50/5 border border-background-50/15">
                  <div className="w-full aspect-[16/10] overflow-hidden bg-foreground-900">
                    <img
                      src={drama.poster}
                      alt={`${drama.title} 独播韩剧海报`}
                      title={`${drama.title} 韩剧 独播剧场`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="font-heading font-bold text-background-50 truncate">
                        {drama.title}
                      </h3>
                      <span className="text-xs font-label text-accent-300 whitespace-nowrap">
                        {drama.score.toFixed(1)}
                      </span>
                    </div>
                    <p className="mt-2 text-xs font-label text-background-50/60">
                      {drama.year} · 共{drama.episodes}集 · {drama.genres.join(" / ")}
                    </p>
                    <p className="mt-2 text-sm text-background-50/70 leading-relaxed line-clamp-2">
                      {drama.synopsis}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}